module.exports = __webpack_public_path__ + "static/media/ICONS_TIPOS DE MOVIMIENTOS.f53281fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ICONS/ICONS_TIPOS DE MOVIMIENTOS.svg
// module id = 490
// module chunks = 0